import React, { useState } from 'react';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Alert, Button, Form } from 'react-bootstrap';
import scoringService from '../../services/ScoringService';

import { v4 as uuidv4 } from 'uuid';

const Dropgoal = (props) => {

    const { homeTeam, awayTeam, fixtureRoomId, startTeamId, realMarkerX, realMarkerY, videoTime, clipStartTime, half, dropgoalKicker, clipId, onDropgoalResult, displayKickInfo } = props;

    const [scoreErrorMessages, setScoreErrorMessages] = useState(null);
    const [errorInputIds, setErrorInputIds] = useState(null);
    const [selectedScore, setSelectedScore] = useState();
    const [dropgoalInPlay, setDropgoalInPlay] = useState(false);

    const handleSuccessfulDropgoal = async () => {
            if (realMarkerX == null || realMarkerY == null) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Please set drop goal coordinates" }]);
            } else {
                scoringService.addDropGoal(fixtureRoomId, startTeamId, clipId, videoTime, 2, realMarkerX, realMarkerY, dropgoalKicker.position, 1, [{ key: 7, value: 1 }], half, true, false, dropgoalKicker.shirtNumber);
                onDropgoalResult(null)
            }
    }

    const handleUnsuccessfulPenalty = async () => {
        if (realMarkerX == null || realMarkerY == null) {
            setScoreErrorMessages([{ id: uuidv4(), text: "Please set drop goal coordinates" }]);
        } else {
            if (dropgoalKicker == null) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Please select a Kicker" }]);
            } else {
                scoringService.addDropGoal(fixtureRoomId, startTeamId, clipId, videoTime, 2, realMarkerX, realMarkerY, dropgoalKicker.position, -1, [{ key: 7, value: 1 }], half, false, false, dropgoalKicker.shirtNumber);
                onDropgoalResult(null)
            }
    }}

    const handleUnsuccessfulPenaltyInPlay = async () => {
        if (realMarkerX == null || realMarkerY == null){
            setScoreErrorMessages([{ id: uuidv4(), text: "Please set drop goal coordinates" }]);
        } else {
            if (videoTime <= clipStartTime) {
                setScoreErrorMessages([{ id: uuidv4(), text: "Penalty result must come after Penalty awarded" }]);
            } else {
                if (dropgoalKicker == null) {
                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select a player" }]);
                } else if (selectedScore == null) {
                    setScoreErrorMessages([{ id: uuidv4(), text: "Please select a score" }]);
                } else {
                    scoringService.addDropGoal(fixtureRoomId, startTeamId, clipId, videoTime, 2, realMarkerX, realMarkerY, dropgoalKicker.position, selectedScore, [{ key: 7, value: 1 }], half, false, true, dropgoalKicker.shirtNumber);
                    onDropgoalResult(null)
                    displayKickInfo()
            }}
    }}
    
    const isButtonDisabled = () => {
        if (dropgoalInPlay == true) {
            return true
        } else {
            return false
        }
    }

    const getScoreErrorMessageSpan = () => {
        if (scoreErrorMessages && scoreErrorMessages.length > 0) {

            let result = [];

            for (let i = 0; i < scoreErrorMessages.length; i++) {
                let current = scoreErrorMessages[i];
                result.push(
                    <Alert key={current.id} variant="danger" className="text-center my-1" onClose={() => {
                        setScoreErrorMessages(scoreErrorMessages && scoreErrorMessages.length > 0 ? scoreErrorMessages.filter((x) => x.id != current.id) : null);
                        setErrorInputIds(errorInputIds && errorInputIds.length > 0 ? errorInputIds.filter((x) => x != current.id) : null);
                    }} dismissible>
                        <span>{current.text}</span>
                    </Alert>);
            }

            return <div className="mb-1" style={{ maxHeight: '240px', overflowY: 'scroll' }}>{result}</div>;
        }
    }

    const scoreErrorMessageSpan = getScoreErrorMessageSpan();

    return <>

        <div className="col-md-12 text-center">
                    <h3>Drop Goal</h3>
            
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Team: &nbsp; </b></span>
                        <span className="py-1">{startTeamId == homeTeam.id ? homeTeam.name : awayTeam.name }</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"><b>Player: &nbsp;</b></span>
                        <span className="py-1">{dropgoalKicker.key}</span>
                        </div>
                    </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Category: &nbsp; </b></span>
                            <span className="py-1">Drop Goal</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="d-flex">
                        <span className="py-1"> <b>Location: &nbsp; </b></span>
                            <span className="py-1">x: {Math.round(realMarkerX)}m y: {Math.round(realMarkerY)}m</span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="danger" 
                        disabled={isButtonDisabled()} 
                        onClick={async () => {
                            await handleUnsuccessfulPenalty(realMarkerX, realMarkerY);
                            }}>Missed Dropgoal</Button>
                    </div>
                </Col>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="success" 
                        disabled={isButtonDisabled()} 
                        onClick={async () => {
                            await handleSuccessfulDropgoal(realMarkerX, realMarkerY);
                            }}>Successful Dropgoal</Button>
                    </div>
                </Col>
                </Row>
            <Row><p> </p></Row>
            <Row>
                <div className="col-md-12 text-right">
                    <Button className="col-md-12 text-center" 
                    variant="outline-danger"
                    onClick={async () => {
                        dropgoalInPlay ? setDropgoalInPlay(false) : setDropgoalInPlay(true)
                        }}>Remained in play</Button>
                </div>
            </Row>
            {dropgoalInPlay == true &&
            <div>
            <Row className="pt-2">
                <Col>
                    <div className="d-flex">
                        <span className="py-1"><b>Select Player Score:</b></span>
                        <Form.Control as="select"
                            size="sm"
                            value={selectedScore}
                            onChange={(event, value) => setSelectedScore(event.target.value)}
                            className="ml-1"
                            style={{ width: '175px' }}>   
                            <option value={0}>Please select score...</option>   
                            <option key={0} value={0}>0</option>
                            <option key={1} value={-0.125}>-0.125</option>
                            <option key={2} value={-0.25}>-0.25</option>
                            <option key={3} value={-0.5}>-0.5</option>
                            <option key={4} value={-1}>-1</option>
                            <option key={5} value={-1.5}>-1.5</option>
                            <option key={6} value={-2}>-2</option>
                            <option key={7} value={-2.5}>-2.5</option>
                            <option key={8} value={-3}>-3</option>
                            <option key={9} value={-3.5}>-3.5</option>
                            <option key={10} value={-4}>-4</option>
                        </Form.Control>
                        </div>
                    </Col>
            </Row>
            <Row><p></p></Row>
            <Row>
                <Col>
                    <div className="col-md-12 text-center">
                        <Button variant="success" 
                        onClick={async () => {
                            await handleUnsuccessfulPenaltyInPlay(realMarkerX, realMarkerY);
                            }}>Submit</Button>
                    </div>
                </Col>
            </Row>
            </div>}
            </div> 
            

            {scoreErrorMessageSpan}
    </>;
}

export default Dropgoal;